interface GreetingUser {
  name?: string;
  givenName?: string;
}

export function getGreetingName(user?: GreetingUser | null): string | undefined {
  const savedName = user?.name?.trim();
  if (savedName) {
    return savedName;
  }

  const givenName = user?.givenName?.trim();
  if (givenName) {
    return givenName;
  }

  return undefined;
}
